import { FC, useMemo } from 'react';
import FilterForm from '../FilterFormItem/FilterFormItem';
import {
  atlasSearch,
  createFilters,
  FilterElements,
  FilterType,
  FilterTypeToFilter,
} from '../../common/filters-utils/filters-utils';
import { Typography, useTheme } from '@mui/material';
import { isDevelopment } from 'env-utils';

const FiltersForm: FC<React.PropsWithChildren<FiltersFormProps>> = ({
  filterByList,
  filterTypeToFilterBy,
  onChangeFilter,
  filterList,
  itemHeight,
  maxHeight,
  disabled,
  isStatistic,
  applicationSelected,
  filterByListTemp,
  isIssues,
}) => {
  const theme = useTheme();
  const filterBy = useMemo(
    () =>
      atlasSearch(filterTypeToFilterBy) &&
      filterByListTemp &&
      isIssues &&
      isDevelopment()
        ? createFilters(filterByListTemp)
        : createFilters(filterByList),
    [filterByList, filterByListTemp, filterTypeToFilterBy, isIssues],
  );
  if (!filterBy) {
    return null;
  }
  return (
    <>
      {isStatistic && (
        <Typography
          variant='body2'
          color='text.primary'
          fontWeight={600}
          p={1}
          sx={{ backgroundColor: theme.palette.background.default }}>
          {FilterType[filterTypeToFilterBy] || filterTypeToFilterBy}
        </Typography>
      )}
      <FilterForm
        disabled={disabled}
        selected={filterList[filterTypeToFilterBy]}
        filterBy={filterBy}
        onFilterChange={onChangeFilter}
        filterTypeToFilterBy={filterTypeToFilterBy}
        itemHeight={itemHeight}
        maxHeight={maxHeight}
        isStatistic={isStatistic}
        applicationSelected={applicationSelected}
      />
    </>
  );
};

export interface FiltersFormProps {
  filterByList: FilterElements[];
  filterByListTemp?: FilterElements[];
  filterTypeToFilterBy: FilterTypeToFilter;
  onChangeFilter?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filterList: {};
  itemHeight: number;
  maxHeight: number;
  disabled?: boolean;
  isStatistic?: boolean;
  applicationSelected?: string;
  isIssues?: boolean;
}

export default FiltersForm;
